import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  TOKEN = 'Bearer ';

  constructor(private httpClient: HttpClient) { }

  authenticateUser(crendentials) {
    return this.httpClient.post(`${environment.api_rul}/authenticate`, crendentials);
  }

  resetPassword(userDetails) {
    return this.httpClient.post(`${environment.api_rul}/resetpassword`, userDetails);
  }

  isAuthenticated() {
    if (window.localStorage.getItem('is_authenticated')) {
      if (window.localStorage.getItem('token')) {
        return true
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  validateToken() {
    this.TOKEN = 'Bearer ' + window.localStorage.getItem('token');
    const companyId = window.localStorage.getItem('company_id');
    const logged_user = window.localStorage.getItem('user_id');
    const fy = window.localStorage.getItem('fy');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/dashboard/standard/read/?company_id=` + companyId + '&logged_user=' + logged_user + '&fy=' + fy, {headers: headers});
  }
  
}
